import React from 'react'
import { arrayOf, number, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import { useContainerWidth, PersonBlock, H1, H3 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import getRelationshipStringKeyFromAscendancyNumber from '../../../../../shared/helpers/relationship_helper'
import { extractFourDigitYear } from '../../../../../shared/helpers/factDate_Helper'

const getPrice = (arr, year) => {
  if (arr.length !== 0 && year) {
    return (
      arr.find((item) => {
        return item?.year?.toString() === year?.toString()
      })?.textHeadline ?? ''
    )
  }
  return ''
}

export default function LineChartPanel({ gender, thumbnailIcon, person, year, showPersonBlock, yearPrices = [] }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const birthYear = extractFourDigitYear(person?.dob)
  const age = year - birthYear
  const strType = age > 0 ? 'yearTurnedAge' : 'yearBorn'
  const yearPrice = yearPrices?.length > 0 && getPrice(yearPrices, year)

  const containerStyleStyle = css`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `

  return (
    <div css={{ width: '100%', maxWidth: '400px' }}>
      {showPersonBlock && (
        <div css={{ padding: atWidth({ default: '10px', lg: '20px' }) }}>
          <PersonBlock
            size={atWidth({ default: 'md', lg: 'lg', xl: 'xl' })}
            avatarProps={{
              sex: gender,
              src: thumbnailIcon,
            }}
            name={`${year}`}
            details={
              person?.atn && t(getRelationshipStringKeyFromAscendancyNumber(person?.atn, gender, strType), { age })
            }
          />
        </div>
      )}
      <div css={containerStyleStyle}>{yearPrice && <H1 centered>{yearPrice}</H1>}</div>
      {!yearPrice && <H3 centered>{t('aam.no.data.for.year', "We don't have data for the selected year")}</H3>}
    </div>
  )
}

Event.propTypes = {
  yearPrices: arrayOf(
    shape({
      category: string,
      categoryId: number,
      icon: string,
      id: number,
      languageOnly: string,
      localeOnly: string,
      price: number,
      subcategory: string,
      textHeadline: string,
      textTitle: string,
      tileType: string,
      year: number,
    })
  ),
}
